export const locales = {
	placeholder: '…'
};
